export const removeNumberSeparators = (number: string): string => number.replace(/,|\.|\s/g, "");
